module.exports = __webpack_public_path__ + "img/type-strikethrough-02.fefacf90.svg";